

<div *ngIf="showMessage" class="status-modal-box  transition delay scale-1" [ngClass]="{'show-modal-box': showMessage, 'hide-modal-box': !showMessage}">
    <div class="status-card transition w-100per position-fixed top-10 bg-white-color modal-box-card d-flex flex-y-center w-100per justify-space-between p-10-20 bdr-radius-10 mb-10">
      <div class="d-flex flex-y-center">
        <img
          src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/{{alertType=='error-box' ? 'red-circle-error.svg' :
            alertType=='success-box' ? 'green-sucess.svg' : 
            alertType=='warning-box' ? 'red-warning.svg' : 
            null }}"
          width="20px"
          height="20px"
          alt="alert-logo"
          class="mr-20"
        />
        <div class="ml-10">
          <h4 class="m-0 text-size-18 text-bold"
          [ngClass]="{'text-red': alertType=='error-box', 'text-orange-color': alertType=='warning-box', 'text-green' :  alertType=='success-box' }">
            {{alertType === "error-box"
            ? "Error"
            : alertType === "warning-box"
            ? "Warning"
            : alertType === "success-box"
            ? "Success"
            : null}}
          </h4>
          <small className="text-dark-grey-color text-size-12 mt-5 mb-0">
           {{message}}
          </small>
        </div>
      </div>
      <img
        src="{{commonService.aws_asset_url}}/_assets/icons/red-close.svg"
        alt="close-btn"
        (click)="hideError()"
        className=" close-btn"
      />
    </div>
  </div>

<div class="ledger-container  ">
    <div class="row tab-nav pl-0 pr-0">
		<!-- <div class="col-sm-4 pl-0">
			<ul class="list-inline list-unstyled p-0 m-0">
				<li class="active page-title text-uppercase cursor"> View Client</li>
			</ul>
		</div> -->
		<div class="col-sm-4 ">
		  <ul class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0">
			  <li [routerLink]="['/']"
				  class="text-grey text-capitalize cursor  hover-text-primary transition"> Utilities</li>
			  <li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg" alt=""></li>
			  <li class="text-grey text-capitalize cursor text-primary transition"> Commission Update</li>
		  </ul>
        </div>
        
	</div>
        <form [formGroup]="commissionForm!">
            <div class="custom-form form-container  pl-15 pr-15" style="width: 600px;
            margin: 20px unset;">
            <div class="text-input-group d-flex justify-content-between">
                <div class="text-input-field mr-2">
  <select  class="input-field" formControlName="transcation_type" tabindex="1">
    <option value="all">Both Flight Invoice & Credit Note</option>
    <option value="invoice">Flight Invoice</option>
    <option value="credit-note">Flight Credit Note</option>
    <option value="all-miscellaneous">Both Miscellaneous Invoice & Credit Note</option>
    <option value="miscellaneous-invoice">Miscellaneous Invoice</option>
    <option value="miscellaneous-credit-note">Miscellaneous Credit Note</option>
  </select>
  <label>Transaction Type</label>
</div>
</div>
            <div class="text-input-group d-flex justify-content-between">
                <div class="text-input-field mr-2">
                    <select class="input-field" tabIndex="4" formControlName="commission_type" (change)="changeCommissionType($event.target.value)">
                        <option value="received">Received</option>
                        <option value="paid">Paid</option>
                    </select>
                    <label>Commission Type</label>
                </div>

                <div class="text-input-field" style="width: 100px;" *ngIf="['all','invoice','credit-note'].includes(commissionForm.value.transcation_type) ">
                    <select class="input-field" name="invoice_type" tabIndex="5"
                        formControlName="invoice_type">
                            <option value="">Select</option>
                            <option value="B">BSP</option>
                            <option value="C">C-R</option>
                            <option value="X">X-O</option>
                    </select>
                    <label>INV Type</label>
                </div>

            </div>
            <div class="text-input-group d-flex justify-content-between">
                <div class="text-input-field mr-2">
                    <input class="input-field"  name="start_date" tabIndex="6"
                        formControlName="start_date" type="date" />
                    <label>START DATE</label>
                </div>
                <div class="text-input-field mr-2">
                    <input class="input-field"  name="end_date" tabIndex="7"
                        formControlName="end_date" type="date" />
                    <label>END DATE</label>
                </div>
                
            </div>

            <div class="text-input-group d-flex justify-content-between" *ngIf="['all','invoice','credit-note'].includes(commissionForm.value.transcation_type) ">
                 <div class="text-input-field" tabIndex="8">
                    <!-- <ng-multiselect-dropdown #accountAC [placeholder]="'Airline'" [settings]="dropdownSettings"
                        [data]="airlineList" formControlName="selectedAirline">
                    </ng-multiselect-dropdown> -->
                     <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="6"
            formControlName="selected_airline" (change)="getAirlineName($event.target.value)">
            <option *ngFor="let airline of airlineList" value="{{airline.account_code}}">{{airline.name}}</option>
          </select>
          <label>Airline</label>
                </div> 

            </div>
            <div class="text-input-group d-flex justify-content-between"
                *ngIf="commissionForm?.value?.commission_type == 'paid'">
                <div class="text-input-field" tabIndex="9">
                    <!-- <ng-multiselect-dropdown #accountAC [placeholder]="'Client'"  [settings]="dropdownSettings"
                        [data]="clientList" formControlName="selectedClient">
                    </ng-multiselect-dropdown> -->
                     <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="6"
            formControlName="selected_client" (change)="getClientName($event.target.value)">
            <option *ngFor="let client of clientList" value="{{client.account_code}}">{{client.name}}</option>
          </select>
          <label>Client</label>
                </div>

            </div>

            <div class="text-input-group d-flex justify-content-between"
                *ngIf="commissionForm?.value?.commission_type == 'received'">
                <div class="text-input-field" tabIndex="10">
                    <!-- <ng-multiselect-dropdown [settings]="dropdownSettings" name="supplier" [placeholder]="'Supplier'"
                        [data]="supplierList" formControlName="selectedSupplier">
                    </ng-multiselect-dropdown> -->
                     <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="6"
            formControlName="selected_supplier" (change)="getSupplierName($event.target.value)">
            <option *ngFor="let supplier of supplierList" value="{{supplier.account_code}}">{{supplier.name}}</option>
          </select>
          <label>Supplier</label>
                </div>
            </div>
            <div class="commission-tbl"  *ngIf="['all','invoice','credit-note'].includes(commissionForm.value.transcation_type) ">
                <table width="100%" cellpadding="0" cellspacing="0">
                    <thead style="display: table-header-group;">
                        <tr>
                            <th class="col-sm-4 border font-500" style="padding-left: 15px!important;">Name</th>
                            <th class="col-sm-4 border font-500">Type</th>
                            <th class="col-sm-4 border font-500">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row">
                            <td class="col-sm-4 border">IATA</td>
                            <td class="col-sm-4 border">
                                <select formControlName="iata_type" tabIndex="11"
                                    class="traveller-inner-input-field text-left w-100">
                                    <option value="RB">RB</option>
                                    <option value="RR">RR</option>
                                    <option value="RY">RY</option>
                                    <option value="RQ">RQ</option>
                                    <option value="RT">RT</option>
                                    <option value="VL">VL</option>
                                </select>
                            </td>
                            <td class="col-sm-4 border">
                                <input formControlName="iata_value" tabIndex="12" class="traveller-inner-input-field text-right w-100" type="number" />
                            </td>
                        </tr>
        
                        <tr class="table-row">
                            <td class="col-sm-4 border">PLB</td>
                            <td class="col-sm-4 border">
                                <select formControlName="plb_type" class="traveller-inner-input-field text-left w-100"
                                    tabIndex="12">
                                    <option value="RB">RB</option>
                                    <option value="RR">RR</option>
                                    <option value="RY">RY</option>
                                    <option value="RQ">RQ</option>
                                    <option value="RT">RT</option>
                                    <option value="VL">VL</option>
                                </select>
                            </td>
                            <td class="col-sm-4 border"><input formControlName="plb_value" tabIndex="13"
                                    class="traveller-inner-input-field text-right w-100" type="number" /></td>
                        </tr>
        
                        <tr class="table-row">
                            <td class="col-sm-4 border">Cashback</td>
                            <td class="col-sm-4 border">
                                <select formControlName="cashback_type" class="traveller-inner-input-field text-left w-100"
                                    tabIndex="14">
                                    <option value="RB">RB</option>
                                    <option value="RR">RR</option>
                                    <option value="RY">RY</option>
                                    <option value="RQ">RQ</option>
                                    <option value="RT">RT</option>
                                    <option value="VL">VL</option>
                                </select>
                            </td>
                            <td class="col-sm-4 border"><input formControlName="cashback_value" tabIndex="15"
                                    class="traveller-inner-input-field text-right w-100" type="number" /></td>
                        </tr>
        
                        <tr class="table-row" style="opacity: 0.5;">
                            <td class="col-sm-4 border">Disc. Recall</td>
                            <td class="col-sm-4 border"></td>
                            <td class="col-sm-4 border">
                                <input formControlName="discRecallValue" tabIndex="16"
                                    class="traveller-inner-input-field text-right w-100" type="number" readonly /></td>
                        </tr>
    
                    </tbody>
                </table>
            </div>
            <div class="commission-tbl"  *ngIf="['all-miscellaneous','miscellaneous-invoice','miscellaneous-credit-note'].includes(commissionForm.value.transcation_type) ">
                <table width="100%" cellpadding="0" cellspacing="0">
                    <thead style="display: table-header-group;">
                        <tr>
                            <th class="col-sm-4 border font-500" style="padding-left: 15px!important;">Name</th>
                            <th class="col-sm-4 border font-500">Type</th>
                            <th class="col-sm-4 border font-500">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row">
                            <td class="col-sm-4 border">COMMISSION</td>
                            <td class="col-sm-4 border">
                                <select formControlName="com_type" tabIndex="11"
                                    class="traveller-inner-input-field text-left w-100">
                                    <option value="RB">RB</option>
                                    <option value="RR">RT</option>
                                    <option value="VL">VL</option>
                                </select>
                            </td>
                            <td class="col-sm-4 border">
                                <input formControlName="commission_value" tabIndex="12" class="traveller-inner-input-field text-right w-100" type="number" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="btn-field bottom-btns-container mt-30 d-flex align-item-center ml-0 mr-0">
            <button type="button" class="btn-style bg-green mr-3" tabIndex="17"
                    (click)="submit(commissionForm.value)">Modify</button>
                <button type="button" class="btn-style bg-green mr-3" tabIndex="18" (click)="reset()">Reset</button>
            </div>
        </form>

    
</div>